import { useEffect } from "react"
import Script from "next/script"
import sanitize from "utilities/sanitize"

export default function RaisersEdgeEmbed({ blok: { form_id } }) {
  const id = sanitize(form_id)

  return (
    <>
      <div className="h-full w-full" id={`blackbaud-donation-form_${id}`}></div>
      <Script
        id="donor_form"
        src="https://sky.blackbaudcdn.net/static/donor-form-loader/2/main.js"
        onReady={() => {
          window.BBDonorFormLoader.newBlackbaudDonationFormZoned("renxt", "p-gKVat8lu20ONv9EOtkN04w", `${id}`, "usa")
        }}
      />
    </>
  )
}
